import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const attempts = ['Fallaste porque intentaste resolver un problema biológico con soluciones psicológicas (intentar "pensar" en el deseo no funciona si tu cuerpo está en alerta).', 'Fallaste porque compraste lencería o juguetes caros esperando que el estímulo externo encendiera un motor interno que está desconectado.', 'Fallaste porque creíste que era falta de amor o de libido, cuando en realidad es un exceso de cortisol bloqueando tus receptores de oxitocina.', 'Fallaste porque intentaste forzar el "acelerador" sin antes aprender a soltar el "freno de mano" de tu sistema nervioso.'];
export function FailedAttemptsSection() {
  return <section className="py-12 px-6 bg-cream" data-id="element-23">
      <div className="max-w-4xl mx-auto" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-25">
          <span className="text-gold tracking-widest uppercase text-sm font-semibold mb-4 block" data-id="element-26">
            La Verdad Oculta
          </span>
          <h2 className="text-3xl md:text-4xl font-playfair text-burgundy-deep" data-id="element-27">
            Por qué lo que intentaste no funcionó
          </h2>
        </motion.div>

        <div className="space-y-6" data-id="element-28">
          {attempts.map((attempt, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} viewport={{
          once: true,
          margin: '-50px'
        }} className="flex items-start gap-4 p-6 rounded-sm bg-white/50 border border-cream-dark shadow-sm" data-id="element-29">
              <div className="flex-shrink-0 mt-1" data-id="element-30">
                <div className="w-8 h-8 rounded-full bg-burgundy/10 flex items-center justify-center" data-id="element-31">
                  <XIcon className="w-4 h-4 text-burgundy" data-id="element-32" />
                </div>
              </div>
              <p className="text-lg text-charcoal/80 leading-relaxed" data-id="element-33">
                {attempt}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}